import React, { Component, Fragment } from 'react'
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUserInfo, logout } from "../../actions/user"
import { clearCartInfo } from '../../actions/cart'
import { clearOrderInfo } from '../../actions/checkout'
import { updatePassword } from '../../actions/changePassword';
import { updateUserInfo } from "../../actions/updUserInfo";
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';

var loading = <img src={require('../../assets/images/loader.gif')} width={20} height={20} />;

class ChangePassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cons_old_password: "",
            cons_new_password: "",
            cons_new_password_cnfm: "",
            mobile_no_encrypt_flag: "N",
            uniqueId: '',

        }
        this.validator = new SimpleReactValidator();
    }

    componentDidMount() {
        if (this.props.location && this.props.location.search) {
            let url = this.props.location.search;
            // let params = queryString.parse(url);
            const params = new URLSearchParams(window.location.search)
            let mobile_unique_id = "";
           
            if(params.get('mobile_no').indexOf(' ') >= 0){
                 mobile_unique_id = params.get('mobile_no').replace(/ /g, "+");
            }
            else
            {
                 mobile_unique_id = params.get('mobile_no');
            }
            
            if (params.get('mobile_no')) {
                this.setState({
                    mobile_no_encrypt_flag: 'Y',
                    uniqueId: mobile_unique_id
                })
            }
        }
    }

    handleBack = () => {
        // this.props.history.push(`/profile`)
        this.props.history.goBack()
    }

    handleChange(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        
        if (this.state.cons_new_password === this.state.cons_new_password_cnfm) {
            if (this.validator.allValid()) {
                const { userDetails, connection_id } = this.props;
                let options ={}
                if (this.state.mobile_no_encrypt_flag === 'Y') {
                    options = {
                        connection_id,
                        mobile_no: this.state.uniqueId,
                        mobile_no_encrypt_flag: this.state.mobile_no_encrypt_flag,
                        cons_old_password: this.state.cons_old_password,
                        cons_new_password: this.state.cons_new_password_cnfm
                    }
                } else {
                    options = {
                        connection_id,
                        mobile_no: userDetails.COM_CONSUMER_MOBILE_NO,
                        mobile_no_encrypt_flag: this.state.mobile_no_encrypt_flag,
                        cons_old_password: this.state.cons_old_password,
                        cons_new_password: this.state.cons_new_password_cnfm
                    }
                }

                this.props.updatePassword(options)
                setTimeout(() => {
                    this.props.logout();
                    this.props.clearCartInfo();
                    this.props.clearOrderInfo();
                    this.props.history.push(`/login`, { from: 'reset' })
                }, 500)
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        }
        else {
            toast.error(`New pasword and Confirm new password don't match. Please re-enter.`);
        }
    }

    render() {

        return (
            <Fragment>
                <section className="tab-product m-0">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-lg-6">
                                <Tabs className="tab-content nav-material">
                                    <TabList className="nav nav-tabs nav-material">
                                        <Tab className="nav-item" style={{ width: "50%" }}>
                                            <span className="nav-link" >
                                                <i className="icofont icofont-contacts"></i>CHANGE PASSWORD</span>
                                            <div className="material-border"></div>
                                        </Tab>
                                    </TabList>
                                    <TabPanel>
                                        <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmit(e)}>
                                            <div className="form-row">
                                                <div className="col-md-12" style={{ paddingTop: 20 }}>
                                                    <input type="password" className="form-control" id="cons_old_password"
                                                        placeholder="Enter Previous / emailed password" value={this.state.cons_old_password} onChange={(e) => this.handleChange(e)} autocomplete="new-password" />
                                                    {this.validator.message('old password', this.state.cons_old_password, 'required')}
                                                </div>
                                                <div className="col-md-12">
                                                    <input type="password" className="form-control" id="cons_new_password"
                                                        placeholder="Enter New password" value={this.state.cons_new_password} onChange={(e) => this.handleChange(e)} autocomplete="new-password" />
                                                    {this.validator.message('new password', this.state.cons_new_password, 'required|min:8')}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 20 }}>
                                                    <input type="password" className="form-control" id="cons_new_password_cnfm"
                                                        placeholder="Confirm New password" value={this.state.cons_new_password_cnfm} onChange={(e) => this.handleChange(e)} autocomplete="new-password" />
                                                    {this.validator.message('new password conifimration', this.state.cons_new_password_cnfm, 'required|min:8')}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 30 }}>
                                                    <div style={{ display: "flex" }}>
                                                        <div style={{ flexGrow: 5, textAlign: "center" }}>
                                                            <button type="button" className="btn btn-solid" style={{ width: "99%" }} onClick={() => this.handleBack()}>Back</button>
                                                        </div>
                                                        <div style={{ flexGrow: 5, textAlign: "center" }}>
                                                            <button type="submit" className="btn btn-solid" style={{ width: "99%" }}>Save</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    userDetails: state.user.user_details,
    connection_id: state.tenant.connection_id,
    updatingUser: state.updateUser.loading
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getUserInfo, updateUserInfo, updatePassword, logout, clearCartInfo, clearOrderInfo },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ChangePassword));
